import { render } from "./Tem006.vue?vue&type=template&id=66704e37&scoped=true"
import script from "./Tem006.vue?vue&type=script&lang=js"
export * from "./Tem006.vue?vue&type=script&lang=js"

import "./Tem006.vue?vue&type=style&index=0&id=66704e37&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66704e37"]])

export default __exports__